import React, { useState } from 'react';
import { LuChevronDown } from 'react-icons/lu';
import Table, { tdClass } from '../../../components/common/Table';
import Badge, { toneForStatus } from '../../../components/common/Badge';

/**
 * One class in a report: a header row with the class and the number of reports;
 * click it to open the list of report items.
 */
export default function ClassAccordion({ title, items, onSelectItem }) {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div className="overflow-hidden rounded-xl border border-ui-line bg-ui-card shadow-card">
            <button
                type="button"
                onClick={() => setIsExpanded(!isExpanded)}
                aria-expanded={isExpanded}
                className="flex w-full items-center justify-between gap-4 px-5 py-3.5 text-left transition-colors hover:bg-ui-muted"
            >
                <div className="flex items-center gap-3">
                    <h2 className="text-[15px] font-semibold text-ui-ink">Class {title}</h2>
                    <Badge tone="grey">
                        {items.length} {items.length === 1 ? 'report' : 'reports'}
                    </Badge>
                </div>
                <LuChevronDown aria-hidden className={`size-5 text-ui-ink-3 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`} />
            </button>

            <div className={`grid transition-[grid-template-rows] duration-200 ease-out ${isExpanded ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
                <div className="overflow-hidden">
                    <div className="border-t border-ui-line-soft">
                        <Table head={['Title', 'Section', 'Status']}>
                            {items.map((item) => (
                                <tr key={item.id} onClick={() => onSelectItem(item)} className="cursor-pointer">
                                    <td className={`${tdClass} font-medium`}>
                                        <button
                                            type="button"
                                            tabIndex={isExpanded ? undefined : -1}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                onSelectItem(item);
                                            }}
                                            className="rounded text-left hover:underline"
                                        >
                                            {item.title || 'Untitled'}
                                        </button>
                                    </td>
                                    <td className={tdClass}>{item.sec || '—'}</td>
                                    <td className={tdClass}>
                                        <Badge tone={toneForStatus(item.status)}>{item.status}</Badge>
                                    </td>
                                </tr>
                            ))}
                        </Table>
                    </div>
                </div>
            </div>
        </div>
    );
}
